// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsvideoconfig = {
    "awsInputVideo": "unicornflix-dev-input-a99olehs",
    "awsOutputVideo": "unicornflix-dev-output-a99olehs.s3.us-east-1.amazonaws.com"
};

export default awsvideoconfig;